<template>
  <footer class="footer">
    <div class="footer-content">
      <!-- 主要内容区 -->
      <div class="footer-main">
        <!-- 公司信息 -->
        <div class="company-info">
          <div class="logo-container">
            <img :src="icon" alt="公司logo">
          </div>
          <div class="info-content">
            <h3>北京智砼兴华智能科技有限公司</h3>
            <div class="info-item">
              <i class="el-icon-location"></i>
              <span>北京市大兴区龙发大街1号院3号楼6层3单元618</span>
            </div>
            <div class="info-item">
              <i class="el-icon-phone"></i>
              <span>18574931510</span>
            </div>
            <div class="info-item">
              <i class="el-icon-message"></i>
              <span>bjztxh001@163.com</span>
            </div>
          </div>
        </div>
        
        <!-- 快速链接 -->
        <div class="quick-links">
          <h3>快速链接</h3>
          <ul>
            <li><router-link to="/index">首页</router-link></li>
            <li><router-link to="/intro">关于我们</router-link></li>
            <li><router-link to="/product">产品展示</router-link></li>
            <li><router-link to="/system">系统方案</router-link></li>
            <li><router-link to="/software">软件定制</router-link></li>
            <li><router-link to="/company">新闻动态</router-link></li>
            <li><router-link to="/aboutUS">联系我们</router-link></li>
          </ul>
        </div>
        
        <!-- 联系我们 -->
        <div class="contact-us">
          <h3>联系我们</h3>
          <p>如果您有任何问题或需求，请随时与我们联系</p>
          <div class="contact-button">
            <router-link to="/aboutUS" class="contact-btn">立即咨询</router-link>
          </div>
          <div class="slogan">
            <p>Focus on software development and services</p>
            <h2>专注于软件研发和服务</h2>
          </div>
        </div>
      </div>
      
      <!-- 版权信息 -->
      <div class="copyright-bar">
        <div class="copyright-text">
          <span>© 2023 北京智砼兴华智能科技有限公司 版权所有</span>
          <span>京ICP备2023017169号</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "copyright",
  data() {
    return {
      icon: require('../assets/12.png'),
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #2c3e50;
  color: #fff;
  padding: 0;
  width: 100%;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

/* 主要内容区 */
.footer-main {
  top: 1500;
  display: flex;
  justify-content: space-between;
  padding: 50px 20px;
  flex-wrap: wrap;
}

/* 公司信息 */
.company-info {
  display: flex;
  max-width: 450px;
  margin-right: 20px;
}

.logo-container {
  margin-right: 20px;
}

.logo-container img {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.info-content h3 {
  font-size: 18px;
  margin-bottom: 15px;
  color: #fff;
  font-weight: 600;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.info-item i {
  margin-right: 10px;
  color: #3498db;
  font-size: 16px;
  margin-top: 3px;
}

/* 快速链接 */
.quick-links {
  min-width: 200px;
}

.quick-links h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #fff;
  font-weight: 600;
  position: relative;
  padding-bottom: 10px;
}

.quick-links h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 3px;
  background: #3498db;
}

.quick-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.quick-links li {
  margin-bottom: 10px;
}

.quick-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 14px;
  display: inline-block;
  position: relative;
  padding-left: 15px;
}

.quick-links a::before {
  content: '›';
  position: absolute;
  left: 0;
  transition: all 0.3s ease;
}

.quick-links a:hover {
  color: #3498db;
  padding-left: 20px;
}

.quick-links a:hover::before {
  color: #3498db;
}

/* 联系我们 */
.contact-us {
  max-width: 300px;
}

.contact-us h3 {
  font-size: 18px;
  margin-bottom: 15px;
  color: #fff;
  font-weight: 600;
  position: relative;
  padding-bottom: 10px;
}

.contact-us h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 3px;
  background: #3498db;
}

.contact-us p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.6;
}

.contact-button {
  margin-bottom: 25px;
}

.contact-btn {
  display: inline-block;
  padding: 10px 25px;
  background: #3498db;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
}

.contact-btn:hover {
  background: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.slogan {
  margin-top: 20px;
}

.slogan p {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 5px;
  font-style: italic;
}

.slogan h2 {
  font-size: 16px;
  color: #3498db;
  font-weight: 600;
}

/* 版权信息 */
.copyright-bar {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px;
  text-align: center;
}

.copyright-text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

.copyright-text span {
  margin: 0 10px;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .footer-main {
    flex-direction: column;
  }
  
  .company-info, .quick-links, .contact-us {
    margin-bottom: 30px;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .company-info {
    flex-direction: column;
  }
  
  .logo-container {
    margin-bottom: 20px;
    margin-right: 0;
  }
  
  .logo-container img {
    width: 100px;
    height: 100px;
  }
}
</style>